const SocialProof: React.FC = () => {
  return (
    <section className="bg-black text-white py-12 px-4 border-t border-zinc-800">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
          Why Remotion + Claude?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden hover:border-cyan-400/30 transition-all">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-cyan-400 mb-4">
                Code-based video, not timeline editing
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Remotion lets you build videos with React — version control, reusable components, and programmatic rendering. Perfect for indie hackers who already think in code.
              </p>
            </div>
          </div>

          <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden hover:border-cyan-400/30 transition-all">
            <div className="p-6">
              <h3 className="text-lg font-semibold text-cyan-400 mb-4">
                Claude speeds up everything
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Instead of learning animation APIs from scratch, use Claude to generate compositions, tweak timing, and iterate on motion design in minutes — not days.
              </p>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          This guide combines both tools into a workflow you can start using today.
        </p>
      </div>
    </section>
  );
};

export default SocialProof;
